import React, { useEffect, useRef, useState } from "react";
import BreadCrum from "../../components/common/BreadCrum";
import {
  DOWNLOAD_IMG,
  FILEUPLOAD_ICON,
  PDF_IMG,
} from "../../utils/aap-image-constant";
import { useNavigate } from "react-router-dom";
import Input from "../../components/common/input";
import Button from "../../components/common/button";
import {
  addbank,
  postFileUpload,
  uploadCLinicContract,
} from "../../hooks/services/api-services";
import {
  allowedSizes,
  decryptAEStoJSON,
  toastEmitter,
} from "../../utils/utilities";
import { API_RESPONSE } from "../../utils/app-constants";
import { useSelector } from "react-redux";
import { ErrorMsg, fileDownload, handleFormInput, hasValidationErrors, restrictInputByRegex } from "../../utils/form-utils";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../hooks/routes/routes-constant";
import { API_URL } from "../../utils/url-constants";
import { REGEX } from "../../utils/regexValidation";

const MyContractandBank = () => {
  const { t, i18n } = useTranslation();
  const [formError, setFormError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isUploadFileLoading, setIsUploadFileLoading] = useState(false);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const imgRef = useRef();
  const navigate = useNavigate();
  const [isDragging, setIsDragging] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadFileData, setUploadFileData] = useState("");
  const [bankData, setBankData] = useState({
    id: 0,
    languageType: i18n.language,
    clinicId: 0,
    countryName: "",
    email: "",
  });

  useEffect(() => {
    setBankData({
      ...bankData,
      clinicId: userData?.id,
      countryName: userData?.country,
    });
  }, [userData?.id, userData?.country]);

  useEffect(() => {
    if (userData?.bankDetailsResponseList !== null)
      setBankData({
        ...bankData,
        id: userData?.bankDetailsResponseList?.id,
        // bankName: userData?.bankDetailsResponseList?.bankName,
        // iban: userData?.bankDetailsResponseList?.iban,
        // bankAddress: userData?.bankDetailsResponseList?.bankAddress,
        // nationalId: userData?.bankDetailsResponseList?.nationalId,
        // sirenNo: userData?.bankDetailsResponseList?.sirenNo,
        // swiftBicCode: userData?.bankDetailsResponseList?.swiftBicCode,
        // branchName: userData?.bankDetailsResponseList?.bankName,
        languageType: userData?.bankDetailsResponseList?.languageType,
        // clinicName: userData?.bankDetailsResponseList?.clinicName,
        clinicId: userData?.id,
        countryName: userData?.country,
        email: userData?.bankDetailsResponseList?.email,

      })
  }, [userData?.id, userData?.country, i18n.language])

  const handleAddBank = async (e) => {
    e.preventDefault();
    // if (bankData?.clinicName?.trim() === "") {
    //   return toastEmitter("error", "Clinic name is mandatory!");
    // }
     // if (bankData?.iban?.trim() === "") {
    //   return toastEmitter("error", "IBAN  is mandatory!");
    // }
    if (uploadFileData?.trim() === "") {
      return toastEmitter("error", "Sign contract is mandatory!");
    }
   
    if (bankData?.countryName?.trim() === "") {
      return toastEmitter("error", "Country name  is mandatory!");
    }
    if (bankData?.email?.trim() === "") {
      return toastEmitter("error", "email is mandatory!");
    }
    // if (bankData?.bankName?.trim() === "") {
    //   return toastEmitter("error", "Bank name is mandatory!");
    // }

    // if (
    //   userData?.country === "Saudi Arabia" ||
    //   userData?.country === "Germany" ||
    //   userData?.country === "United Arab Emirates"
    // ) {
    //   if (bankData?.nationalId?.trim() === "") {
    //     return toastEmitter(
    //       "error",
    //       "Commercial Registration (CR) Number/National ID/Emirates Id is mandatory!"
    //     );
    //   }
    // }
    // if (userData?.country === "France") {
    //   if (bankData?.sirenNo?.trim() === "") {
    //     return toastEmitter("error", "SIRET/SIREN number is mandatory!");
    //   }
    // }
    if (hasValidationErrors(formError)) {
      toastEmitter("error", "Please correct the errors before submitting.");
      return;
    }
    setIsLoading(true);
    // return
    try {
      const response = await addbank(bankData);
      if (response?.data?.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        if (userData?.bankDetailsResponseList === null) {
        }
        if (uploadFileData) {
          handleFileSubmit(userData?.id, uploadFileData);
        }

      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setIsLoading(false);
    }
  };
  const handleFileSubmit = (clinicId, contractFile) => {
    uploadCLinicContract(clinicId, contractFile)
      .then(function (response) {
        if (response?.data?.status !== 200) {
          toastEmitter("error", response?.data?.message);
        }
        if (response?.data?.status === 200) {
          toastEmitter("success", "Bank details and contract submitted successfully.");
          navigate(ROUTES?.DASHBOARD);
          window?.location?.reload()
        }
        return;
      })
      .catch(function (err) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
        return setIsLoading(false);
      });
  };

  const handleFileUpload = (e) => {
    const val = e.target.files?.[0];
    setFile(val?.name);
    if (!val) {
      toastEmitter("error", "No file selected.");
      return;
    }
    if (val.size > allowedSizes) {
      toastEmitter("error", "File size should not exceed 5MB.");
      imgRef.current.value = null;
      return false;
    }

    setIsUploadFileLoading(true)


    const fileData = new FormData();
    fileData.append("file", val);
    setIsUploadFileLoading(true);
    // setIsLoading(true);
    postFileUpload(fileData)
      .then(function (response) {
        if (response?.data?.status !== 200) {
          toastEmitter("error", response?.data?.message);
        }
        if (response?.data?.status === 200) {
          if (response?.data?.data) {
            toastEmitter("success", response?.data?.message);
            setUploadFileData(response?.data?.data);
          }
          // setIsLoading(false);
        }
        return setIsUploadFileLoading(false);
      })
      .catch(function (err) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
        // setIsLoading(false);
        return setIsUploadFileLoading(false);
      });
  };
  const handleDataBack = () => {
    navigate(ROUTES.DASHBOARD)
  }
  const userCountry = userData?.country;
const isSaudi = userCountry === "Saudi Arabia";
  return (
    <>
      <div className="main_datatable my-lg-3 my-2 bank_tabs">
        <BreadCrum firstData="Bank And Contract" className="fw-600 fs-18" />
        <div className="mb-3 mt-3">
          <div className="add_doctor card p-3 border border-radius_input">
            <div className="row ">
              <p className="fw-600 fs-16">
                Please download the contract, sign it manually and then upload
                it .
              </p>
              <div className="col-6">
                <label htmlFor="">Download Contract</label>
                <div className="buutonlightPrimeryColor  border-radius_input">
                  <div className="d-flex justify-content-between align-items-center justify-content-center p-2">
                    <div className="d-flex ">
                      <img
                        src={PDF_IMG}
                        alt="img"
                        className="img-fluid"
                        style={{ width: "25px" }}
                      />{" "}
                      <span className="mb-0 d-flex justify-content-center align-items-center ms-2">
                        {userData && userData?.contractAdmin && "Contract.pdf"}

                      </span>
                    </div>
                    <div>
                      <img
                        src={DOWNLOAD_IMG}
                        alt="img"
                        className="cursor-pointer"
                        style={{ width: "19px" }}
                        onClick={() =>
                          fileDownload(
                            `${API_URL?.ServerURL}${userData?.contractAdmin}`
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <label htmlFor="">
                  {t("Document Upload")} <span className=" text-danger">*</span>
                </label>
                <label
                  onDragOver={(e) => {
                    e.preventDefault();
                    setIsDragging(true);
                  }}
                  onDragLeave={(e) => {
                    e.preventDefault();
                    setIsDragging(false);
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    setIsDragging(false);
                    const file = e.dataTransfer.files?.[0];
                    if (file) {
                      handleFileUpload({ target: { files: [file] } });
                    }
                  }}
                  className={`w-100 border-1 border-radius_input text-center  mt-0 ${isDragging ? "bg-light border-primary" : ""
                    } ${file ? "bg-light" : ""}`}
                  style={{ borderStyle: "dashed", cursor: "pointer" }}
                >
                  <input
                    ref={imgRef}
                    type="file"
                    className="d-none"
                    id="fileInput"
                    accept=".pdf, .doc, .docx"
                    onChange={handleFileUpload}
                  />
                  <label htmlFor="fileInput" className="cursor-pointer">
                    {isUploadFileLoading && (
                      <i className="fa fa-spinner fa-spin me-2 text-primary"></i>
                    )}
                    <img src={FILEUPLOAD_ICON} alt="file_image" />
                    <span className={` text-muted fw-400 ${i18n.language === "ar" ? "me-2" : "ms-2"}`}>
                      {file === null ? t("Upload Document or Drag Here") : file}
                    </span>
                  </label>

                </label>
              </div>

            </div>
          </div>
        </div>
        <div>
          <form onSubmit={handleAddBank}>
            <div className=" add_doctor card p-3 border border-radius_input">
              <h5 className="mb-2 sec-heading fw-600">Bank Information</h5>
              <div className="row">
                {/* <div className="col-md-6 mb-2">
                  <Input
                    type="text"
                    className="border-radius_input"
                    value={bankData.clinicName}
                    name="clinicName"
                    placeHolder="Enter clinic name"
                    handleChange={(e) =>
                      setBankData(handleFormInput(e, bankData))
                    }
                    error={formError?.clinicName}
                    labelName="Clinic Name"
                    disabled={true}
                  />
                </div> */}
{/*             
                <div className="col-md-6 mb-2 position-relative">
                  <Input
                    type="text"
                    className="border-radius_input"
                    value={bankData.email}
                    name="email"
                    placeHolder="Enter PayPal Email"
                    handleChange={(e) =>
                      setBankData(handleFormInput(e, bankData))
                    }
                    error={formError?.email}
                    labelName="PayPal Email"
                    disabled={false}
                  />
                  <small className="text-muted">
                    Don’t have a PayPal account?{" "}
                    <a
                      href="https://www.paypal.com/signup/account"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary text-decoration-underline"
                    >
                      Create one here
                    </a>
                  </small>
                </div> */}

<div className="col-md-6 mb-2 position-relative">
  {isSaudi ? (
    <>
      <Input
        type="text"
        className="border-radius_input"
        value={bankData.email}
        name="email"
        placeHolder="Enter PayPal Email"
        handleChange={(e) =>
          setBankData(handleFormInput(e, bankData))
        }
        error={formError?.email}
        labelName="PayPal Email"
      />

      <small className="text-muted">
        Don’t have a PayPal account?{" "}
        <a
          href="https://www.paypal.com/signup/account"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary text-decoration-underline"
        >
          Create one here
        </a>
      </small>
    </>
  ) : (
    <>
      <Input
        type="text"
        className="border-radius_input"
        value={bankData.email}
        name="email"
        placeHolder="Enter Stripe Account Email"
        handleChange={(e) =>
          setBankData(handleFormInput(e, bankData))
        }
        error={formError?.email}
        labelName="Stripe Email"
      />

      <small className="text-muted">
        Don’t have a Stripe account?{" "}
        <a
          href="https://dashboard.stripe.com/register"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary text-decoration-underline"
        >
          Create Stripe account
        </a>
      </small>
    </>
  )}
</div>

                {/* <div className="col-md-6 mb-2">
                  <Input
                    type="text"
                    className="border-radius_input"
                    value={bankData?.iban}
                    name="iban"
                    placeHolder="Enter account number"
                    handleChange={(e) =>
                      setBankData(
                        handleFormInput(e, bankData, formError, setFormError)
                      )
                    }
                    onBeforeInput={restrictInputByRegex(/^[A-Z0-9]*$/)}

                    error={formError?.iban}
                    showIcon={false}
                    labelName="IBAN (International Bank Account Number)"
                  />
                  <ErrorMsg error={formError?.iban} />
                </div> */}
                <div className="col-md-6 mb-2">
                  <Input
                    className="border-radius_input"
                    type="text"
                    value={bankData?.countryName}
                    name="country"
                    placeHolder="country"
                    handleChange={(e) =>
                      setBankData(handleFormInput(e, bankData))
                    }
                    showIcon={false}
                    labelName="Country"
                    disabled={true}
                  />

                </div>
                {/* <div className="col-md-6 mb-2">
                  <Input
                    className="border-radius_input"
                    type="text"
                    value={bankData?.bankName}
                    name="bankName"
                    placeHolder="Enter bank name"
                    handleChange={(e) =>
                      setBankData(handleFormInput(e, bankData, formError, setFormError))
                    }
                    error={formError?.bankName}
                    labelName="Bank Name"
                  />
                  <ErrorMsg error={formError?.bankName} />
                </div>

                <div className="col-md-6 mb-2">
                  <Input
                    className="border-radius_input"
                    type="text"
                    value={bankData?.swiftBicCode}
                    name="swiftBicCode"
                    placeHolder="Enter SWIFT/BIC code"
                    handleChange={(e) =>
                      setBankData(handleFormInput(e, bankData))
                    }
                    onBeforeInput={restrictInputByRegex(REGEX.charLevelAlphaNumeric)}
                    error={formError?.swiftBicCode}
                    showIcon={false}
                    labelName="SWIFT/BIC Code (Optional)"
                    showAsterisk={false}
                  />
                  <ErrorMsg error={formError?.swiftBicCode} />
                </div>
                {userData && (
                  (userData.country === "Saudi Arabia" ||
                    userData.country === "United Arab Emirates" ||
                    userData.country === "Germany") && (<div className="col-12 col-md-6">
                      <Input
                        className="border-radius_input"
                        type="text"
                        value={bankData.nationalId}
                        name="nationalId"
                        placeHolder="Enter CR number"
                        handleChange={(e) =>
                          setBankData(handleFormInput(e, bankData))
                        }
                        onBeforeInput={restrictInputByRegex(REGEX.charLevelAlphaNumeric)}
                        error={formError?.nationalId}
                        showIcon={false}
                        labelName="Commercial Registration (CR) number/National ID or Iqama number/Emirates"
                      />
                      <ErrorMsg error={formError?.nationalId} />
                    </div>)
                )}
                {userData && userData?.country === "France" && (
                  <div className="col-12 col-md-6">
                    <Input
                      className="border-radius_input"
                      type="text"
                      value={bankData?.sirenNo}
                      name="sirenNo"
                      placeHolder="Enter Your SIREN"
                      handleChange={(e) =>
                        setBankData(handleFormInput(e, bankData))
                      }
                      onBeforeInput={restrictInputByRegex(REGEX.charLevelAlphaNumeric)}
                      error={formError?.sirenNo}
                      showIcon={false}
                      labelName="SIRET/SIREN Number"
                    />
                    <ErrorMsg error={formError?.sirenNo} />
                  </div>
                )} */}
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3 flex-wrap">
              <Button
                type="button"
                className="px-5 py-2 rounded border-0 cancelbtn me-2 mb-2 mb-sm-0"
                label="Cancel"
                onClick={handleDataBack}
              />
              <Button
                type="submit"
                className=" px-5 py-2 rounded border-0 text-white submitbtn mb-2 mb-sm-0"
                label="Add bank and contract"
                isLoading={isLoading}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default MyContractandBank;
